import React from 'react';
import { Paper, Box, Tabs, Tab } from '@mui/material';
import TabPanel from '../../../components/common/tabs/TabPanel';

import ChanceConfirmFormContainer from '../detail/ChanceConfirmFormContainer';
import SalesActivityTemplate from '../../../components/chancemng/stepper/SalesActivityTemplate';
import ChanceFileTemplate from '../../../components/chancemng/stepper/ChanceFileTemplate';
import SalesHistoryTemplate from '../../../components/chancemng/stepper/SalesHistoryTemplate';

function a11yProps(index) {
  return {
    id: `chance-tab-${index}`,
    'aria-controls': `chance-tabpanel-${index}`,
  };
}

const ChanceConfirmContainer = ({ activeTap, handleTabChange, stepperRef }) => {
  return (
    <Paper
      sx={{
        mt: 1,
        pb: 1,
      }}
    >
      <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTap}
          onChange={handleTabChange}
          aria-label="기회 확인 단계"
        >
          <Tab label="기본사항" {...a11yProps(0)} />
          <Tab label="매입견적서" {...a11yProps(1)} />
          <Tab label="영업활동" {...a11yProps(2)} />
          <Tab label="영업이력" {...a11yProps(3)} />
        </Tabs>
      </Box>
      <TabPanel value={activeTap} index={0}>
        <ChanceConfirmFormContainer stepperRef={stepperRef} />
      </TabPanel>
      <TabPanel value={activeTap} index={1}>
        <ChanceFileTemplate />
      </TabPanel>

      <TabPanel value={activeTap} index={2}>
        <SalesActivityTemplate />
      </TabPanel>
      <TabPanel value={activeTap} index={3}>
        <SalesHistoryTemplate />
      </TabPanel>

      <Box sx={{ width: '100%', borderTop: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTap}
          onChange={handleTabChange}
          aria-label="기회 확인 단계"
          TabIndicatorProps={{ style: { top: 0 } }}
        >
          <Tab label="기본사항" {...a11yProps(0)} />
          <Tab label="매입견적서" {...a11yProps(1)} />
          <Tab label="영업활동" {...a11yProps(2)} />
          <Tab label="영업이력" {...a11yProps(3)} />
        </Tabs>
      </Box>
    </Paper>
  );
};

export default ChanceConfirmContainer;
